import {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function VendorPayment() {
    
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [invoiceList, setInvoiceList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        invoice: "",
        amount: "",
        payment_date: "",
        payment_mode: "",
        transaction_reference: "",
        remarks: ""
    });
    useEffect(() => {
        getPayments();
        getInvoices();
    }, []);
    const getPayments = () => {
        setLoading(true);
        axios.get(baseUrl + "vendor-payment/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getInvoices = () => {
        axios.get(baseUrl + "purchase-order/")
            .then((res) => {
                setInvoiceList(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            invoice: "",
            amount: "",
            payment_date: "",
            payment_mode: "",
            transaction_reference: "",
            remarks: ""
        });
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            invoice: row.invoice.id,
            amount: row.amount,
            payment_date: row.payment_date,
            payment_mode: row.payment_mode,
            transaction_reference: row.transaction_reference,
            remarks: row.remarks
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Vendor Payment?",
            icon: "warning",
            showCancelButton: true
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(baseUrl + `delete-vendor-payment/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted",
                                "",
                                "success");
                            getPayments();
                        });
                }
            });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = new FormData();
            data.append("invoice", formData.invoice);
            data.append("amount", formData.amount);
            data.append("payment_date", formData.payment_date);
            data.append("payment_mode", formData.payment_mode);
            data.append("transaction_reference", formData.transaction_reference);
            data.append("remarks", formData.remarks);
            data.append("addedby", userName);
            data.append("ip_add", ipAddress);
            if (editId === null) {
                await axios.post(baseUrl + "vendor-payment/",
                    data);
            } else {
                await axios.put(baseUrl + `update-vendor-payment/${editId}/`,
                    data);
            }
            Swal.fire("Success",
                editId === null
                    ? "Payment Saved"
                    : "Payment Updated",
                "success");
            clearForm();
            getPayments();
        } catch (error) {
            Swal.fire("Error",
                "Unable to Save Payment",
                "error");
        }
        setLoading(false);
    };
    const columns = [
        {
            field: "invoice",
            headerName: "Invoice",
            width: 180,
           renderCell: (params) =>
            `${params.row.invoice?.id} - ${params.row.invoice?.po_no}`
        },
        {
            field: "amount",
            headerName: "Amount",
            width: 120
        },
        {
            field: "payment_date",
            headerName: "Payment Date",
            width: 140
        },
        {
            field: "payment_mode",
            headerName: "Payment Mode",
            width: 150
        },
        {
            field: "transaction_reference",
            headerName: "Transaction Ref",
            width: 180
        },
        {
            field: "action",
            headerName: "Action",
            width: 280,
            renderCell: (params) => (
                <>


                    <button


                        className="btn btn-success btn-sm me-2"


                        onClick={() => editData(params.row)}


                    >

                        Edit

                    </button>


                    <button


                        className="btn btn-danger btn-sm"


                        onClick={() => deleteData(params.row.id)}


                    >

                        Delete

                    </button>
<button
    className="btn btn-primary btn-sm ms-2"
    onClick={() =>
        window.open(
            `/vendor-payment-print/${params.row.id}`,
            "_blank"
        )
    }
>
    Print
</button>

                </>
            )
        }
    ];
    return (
        <div className="container-fluid mt-3">


            <div className="card shadow">


                <div className="card-header bg-success text-white">


                    <h5 className="mb-0">

                        Vendor Payment

                    </h5>


                </div>


                <div className="card-body">


                    <form onSubmit={saveData}>


                        <div className="row">


                            <div className="col-md-4 mb-3">


                                <label>

                                    Invoice

                                </label>


                                <select


                                    className="form-control"


                                    name="invoice"


                                    value={formData.invoice}


                                    onChange={handleChange}


                                    required


                                >


                                    <option value="">


                                        Select Invoice


                                    </option>


                                    {invoiceList.map((item) => (
                                        <option


                                            key={item.id}


                                            value={item.id}


                                        >


                                            {item.po_no} - Total {item.total}


                                        </option>
                                    ))}


                                </select>


                            </div>


                            <div className="col-md-4 mb-3">


                                <label>

                                    Amount

                                </label>


                                <input


                                    type="number"


                                    step="0.01"


                                    className="form-control"


                                    name="amount"


                                    value={formData.amount}


                                    onChange={handleChange}


                                    required


                                />


                            </div>


                            <div className="col-md-4 mb-3">


                                <label>

                                    Payment Date

                                </label>


                                <input


                                    type="date"


                                    className="form-control"


                                    name="payment_date"


                                    value={formData.payment_date}


                                    onChange={handleChange}


                                    required


                                />


                            </div>

                            <div className="col-md-4 mb-3">


                                <label>

                                    Payment Mode

                                </label>


                                <input


                                    type="text"


                                    className="form-control"


                                    name="payment_mode"


                                    value={formData.payment_mode}


                                    onChange={handleChange}


                                    placeholder="Cash / Bank / UPI"


                                    required


                                />


                            </div>


                            <div className="col-md-4 mb-3">


                                <label>

                                    Transaction Reference

                                </label>


                                <input


                                    type="text"


                                    className="form-control"


                                    name="transaction_reference"


                                    value={formData.transaction_reference}


                                    onChange={handleChange}


                                />


                            </div>


                            <div className="col-md-12 mb-3">


                                <label>

                                    Remarks

                                </label>


                                <textarea


                                    className="form-control"


                                    rows="3"


                                    name="remarks"


                                    value={formData.remarks}


                                    onChange={handleChange}


                                />


                            </div>


                            <div className="col-md-12 mt-3">


                                <button


                                    type="submit"


                                    className="btn btn-success me-2"


                                >


                                    {
                                        editId === null
                                            ? "Save Payment"
                                            : "Update Payment"
                                    }


                                </button>


                                <button


                                    type="button"


                                    className="btn btn-secondary"


                                    onClick={clearForm}


                                >


                                    Clear


                                </button>


                            </div>


                        </div>


                    </form>


                </div>


            </div>

            <div className="card shadow mt-3">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        Vendor Payment List

                    </h5>


                </div>


                <div className="card-body">


                    <div

                        style={{
                            height: 600,
                            width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={rows}


                            columns={columns}


                            loading={loading}


                            getRowId={(row) => row.id}


                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>
    );
}
export default VendorPayment;